import {
  SET_NOTIFICATION_SETTING,
  SET_USER_SCHEDULE,
  SET_USER_SESSION,
  UPDATE_USER_SESSION,
} from "./types";
import { parseAction } from "./REST";
import Parse from "parse";
import config from "../config";
import { PhoneNumber } from "libphonenumber-js";

export const updateNotificationSetting = (setting) => (dispatch) => {
  const method = "post";
  const url = config.BASE_URL + "/parse/functions/setUserNotification";
  const params = {
    notificationType: setting,
  };

  return parseAction(method, url, params, { "Content-Type": "application/json" })
    .then((result) => {
      dispatch({
        type: SET_NOTIFICATION_SETTING,
        setting: setting,
      });
      return result;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
};

export const getUserProfile = (session = "") => (dispatch) => {
  const method = "post";
  const url = config.BASE_URL + "/parse/functions/downloadUserProfile";
  const params = {};
  const sToken = session ? session : null;

  return parseAction(method, url, params, { "Content-Type": "application/json" }, sToken)
    .then((res) => {
      const { result } = res;

      if (result && result.profile) {
        const type = result.profile.setting ? result.profile.setting.notificationType : 1;
        const profile = result.profile;
        profile.sessionToken = sToken;

        dispatch({
          type: SET_NOTIFICATION_SETTING,
          setting: type,
        });

        dispatch({
          type: SET_USER_SESSION,
          userProfile: result.profile,
        });

        return profile;
      }
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getUserSchedule = () => (dispatch) => {
  const method = "post";
  const url = config.BASE_URL + "/parse/functions/fetchUserSchedule";
  const params = {};

  return parseAction(method, url, params, { "Content-Type": "application/json" })
    .then((result) => {
      dispatch({
        type: SET_USER_SCHEDULE,
        // userSchedule: setting,
      });
      return result;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
};

export const setUserSchedule = (schedules) => (dispatch) => {
  const method = "post";
  const url = config.BASE_URL + "/parse/functions/setUserSchedule";
  const params = { schedules };

  return parseAction(method, url, params, { "Content-Type": "application/json" })
    .then((result) => {
      dispatch({
        type: SET_USER_SCHEDULE,
        // userSchedule: setting,
      });
      return result;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
};

export const updateUser = (action) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_SESSION,
    isAvailable: action.isAvailable,
    useSchedule: action.useSchedule,
    unavailabilityReason: action.unavailabilityReason,
  });
};

export const getMembersSchedule = (schedules) => (dispatch) => {
  const method = "post";
  const url = config.BASE_URL + "/parse/functions/getMembersSchedule";
  const params =
    schedules >= 0 ? { day: [schedules], user_time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone } : {};

  return parseAction(method, url, params, { "Content-Type": "application/json" })
    .then((result) => {
      // dispatch({
      //   type: SET_USER_SCHEDULE,
      //   // userSchedule: setting,
      // });
      return result;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
};

export const getTimeZone = () => () => {
  const method = "post";
  const url = config.BASE_URL + "/parse/functions/getTimeZone";
  const params = {};

  return parseAction(method, url, params, { "Content-Type": "application/json" })
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
};

export const signupUser = (parms) => (dispatch) => {
  const method = "post";
  const url = config.BASE_URL + "/parse/functions/signup";
  const params = parms;

  return parseAction(method, url, params, { "Content-Type": "application/json" })
    .then((result) => {
      //
      return result;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
};

export const validateEmailOrMobile = (parms) => (dispatch) => {
  const method = "post";
  const url = config.BASE_URL + "/parse/functions/validateEmailOrMobile";
  const params = { username: parms };

  return parseAction(method, url, params, { "Content-Type": "application/json" })
    .then((result) => {
      //
      return result;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
};